import { Avatar, SIZES, Typography, Tooltip } from 'shared';

type MenuTriggerButtonProps = {
  name: string;
  pictureUrl: string;
  dataTestId?: string;
};

export const MenuTriggerButton = ({
  name,
  pictureUrl,
  dataTestId,
}: MenuTriggerButtonProps) => {
  return (
    <Tooltip
      content={
        <Typography color="white" fontWeight="medium" type="small">
          Menu
        </Typography>
      }
      positioning={{ placement: 'bottom-end', offset: 8 }}
    >
      <Avatar
        name={name}
        size={SIZES.SM}
        src={pictureUrl}
        data-testid={dataTestId ?? `${name} avatar`}
        cursor="pointer"
      />
    </Tooltip>
  );
};
